module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg21-d6935bbcc700da6a3c18e552d5f8afe5.jpg";